import React  from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
// import * as serviceWorker from "./serviceWorker";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./App";
import posthog from "posthog-js";
import ErrorFallBack from "./components/ErrorFallBack/ErrorFallBack.component";

const isDevModeOn = process.env.NODE_ENV === "development";

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY,{api_host:process.env.REACT_APP_PUBLIC_POSTHOG_HOST});
// Bugsnag Initailization
Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['production', 'staging'],
  releaseStage: process.env.NODE_ENV,
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);


if(!isDevModeOn) {
  // Log Rocket Initalization
  LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY);
  // after calling LogRocket.init()
  setupLogRocketReact(LogRocket);
}

ReactDOM.render(
  <ErrorBoundary FallbackComponent={ErrorFallBack}>
    <Router>
      <GoogleReCaptchaProvider
        reCaptchaKey= {process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        scriptProps={{
          async: true,
          defer: true,
        }}
      >
        <App />
      </GoogleReCaptchaProvider>
    </Router>
  </ErrorBoundary>,
  document.getElementById("root")
);

// serviceWorker.register();
